module.exports = __webpack_public_path__ + "static/media/financial-worries.6f2285db.png";